// Add your custom JS here.
// console.log("Custom Script");

/**
 * Sorgt dafür, dass die Seite im parent frame noch oben rutscht
 */
window.scrollparentop = () => {
    if ('parentIFrame' in window) {
        window.parentIFrame.scrollTo(0, 0)
    }
}

window.iFrameResizer = {
    onReady: function () {
        scrollparentop();
    }
}

window.addEventListener("load", (event) => {
    scrollparentop();
});

/**
 * Improved domain detection function
 */
function detectParentDomain() {
    let parentDomain = '';

    // Try multiple methods to get parent domain
    if (window.location !== window.parent.location) {
        // We're in an iframe
        try {
            // Method 1: document.referrer (most reliable for cross-origin)
            if (document.referrer) {
                parentDomain = document.referrer;
            }
        } catch (e) {
            console.log('Cannot access referrer:', e);
        }

        try {
            // Method 2: window.location.ancestorOrigins (Chrome/Safari)
            if (window.location.ancestorOrigins && window.location.ancestorOrigins.length > 0) {
                parentDomain = window.location.ancestorOrigins[0];
            }
        } catch (e) {
            console.log('Cannot access ancestorOrigins:', e);
        }

        try {
            // Method 3: parent.location (only works if same-origin)
            if (window.parent && window.parent.location) {
                parentDomain = window.parent.location.href;
            }
        } catch (e) {
            console.log('Cannot access parent.location (cross-origin):', e);
        }
    } else {
        // Not in iframe, use current location
        parentDomain = window.location.href;
    }

    return parentDomain;
}

/**
 * Mapping der Domains - Fixed version
 */
const ugcMainPage = document.querySelector('.ugc-start-page');
const ugcFormPage = document.querySelector('.ugc-form-page');

if (ugcMainPage) {

    // Improved domain mapping - removed inconsistencies
    let mapURLs = {
        // OCH Region
        "tagblatt.ch": "OCH",
        "appenzellerzeitung.ch": "OCH",
        "thurgauerzeitung.ch": "OCH",

        // ZCH Region
        "luzernerzeitung.ch": "ZCH",
        "obwaldnerzeitung.ch": "ZCH",
        "nidwaldnerzeitung.ch": "ZCH",
        "zugerzeitung.ch": "ZCH",
        "urnerzeitung.ch": "ZCH",

        // NWCH Region
        "aargauerzeitung.ch": "NWCH",
        "grenchnertagblatt.ch": "NWCH",
        "solothurnerzeitung.ch": "NWCH",
        "oltnertagblatt.ch": "NWCH",
        "bzbasel.ch": "NWCH",
        "badenertagblatt.ch": "NWCH",
        "limmattalerzeitung.ch": "NWCH"
    };

    function initializePage() {
        console.log("Version 1.8.4 - Fixed domain detection");

        const mobileRegionCheck = window.location.hash;
        let parentDomain = detectParentDomain();
        let regionSelector = "";

        console.log("Detected parent domain:", parentDomain);
        console.log("Mobile region check:", mobileRegionCheck);

        if (parentDomain) {
            // Check for mobile region override first
            if (mobileRegionCheck === "#zch") {
                regionSelector = "ZCH"; // Fixed: use uppercase for consistency
                console.log("Mobile override - Region set to ZCH");
            } else if (mobileRegionCheck === "#och") {
                regionSelector = "OCH"; // Fixed: use uppercase for consistency
                console.log("Mobile override - Region set to ZCH");
            }
            else if (mobileRegionCheck === "#nwch") {
                regionSelector = "NWCH"; // Fixed: use uppercase for consistency
                console.log("Mobile override - Region set to ZCH");
            }
            else {
                // Domain matching - improved logic
                const keys = Object.keys(mapURLs);

                for (const key of keys) {
                    if (parentDomain.toLowerCase().includes(key.toLowerCase())) {
                        regionSelector = mapURLs[key];
                        console.log("Domain match found:", key, "->", regionSelector);
                        break; // Stop at first match
                    }
                }
            }

            console.log("Final region selector:", regionSelector);

            if (regionSelector) {
                // Set up links with proper error handling
                try {
                    // Extract base domain from parent URL
                    const url = new URL(parentDomain);
                    const baseDomain = url.origin;

                    // Nutzungsbestimmungen & Teilnahmebedingungen
                    const nutzungsElement = document.getElementById('nutzungsbedingungen');
                    const teilnahmeElement = document.getElementById('teilnahmebedingungen');

                    if (nutzungsElement) {
                        nutzungsElement.setAttribute('href', `${baseDomain}/services/agb-nutzungsbedingungen-und-datenschutzerklaerung-ld.994641`);
                        nutzungsElement.setAttribute('target', '_blank');
                    }

                    if (teilnahmeElement) {
                        teilnahmeElement.setAttribute('href', `${baseDomain}/services/teilnahmebedingungen-leserreporter-ld.1044224`);
                        teilnahmeElement.setAttribute('target', '_blank');
                    }

                    // Form page links - use lowercase for URLs
                    const regionLower = regionSelector.toLowerCase();

                    const leserbeitragElement = document.querySelector('.ugc-leserbeitrag');
                    const leserbildElement = document.querySelector('.ugc-leserbild');
                    const leserbriefElement = document.querySelector('.ugc-leserbrief');

                    if (leserbeitragElement) {
                        leserbeitragElement.setAttribute('href', `/${regionLower}-ugc-leserbeitrag`);
                    }
                    if (leserbildElement) {
                        leserbildElement.setAttribute('href', `/${regionLower}-ugc-leserbild`);
                    }
                    if (leserbriefElement) {
                        leserbriefElement.setAttribute('href', `/${regionLower}-ugc-leserbrief`);
                    }

                    // Leserreporter Formular
                    const leserreporterElement = document.querySelector('#leserreporter-formular');
                    if (leserreporterElement) {
                        if (regionSelector === 'ZCH') {
                            leserreporterElement.setAttribute('href', `${baseDomain}/ld.2589381`);
                        } else if (regionSelector === 'OCH') {
                            leserreporterElement.setAttribute('href', `${baseDomain}/ld.2589429`);
                        } else if (regionSelector === 'NWCH') {
                            leserreporterElement.setAttribute('href', `${baseDomain}/ld.2589435`);
                            const leserbriefAAZ = document.querySelector('#leserbrief-aaz');
                            if (leserbriefAAZ) {
                                leserbriefAAZ.style.display = "none";
                            }
                        }
                    }

                    // WhatsApp setup
                    const whatsappButton = document.querySelector('.whatsapp');
                    if (whatsappButton) {
                        if (regionSelector === "NWCH") {
                            whatsappButton.setAttribute('href', 'https://wa.me/41798583412?text=Leserreporter');
                        } else if (regionSelector === "OCH") {
                            whatsappButton.setAttribute('href', 'https://wa.me/41797588535?text=Leserreporter');
                        } else if (regionSelector === "ZCH") {
                            whatsappButton.setAttribute('href', 'https://wa.me/41792925917?text=Leserreporter');
                        }
                    }

                } catch (error) {
                    console.error("Error setting up page links:", error);
                }
            } else {
                console.log("No region selector found for domain:", parentDomain);
            }
        } else {
            console.log("No parent domain detected");
        }
    }

    // Initialize immediately if already loaded, otherwise wait for message
    if (document.readyState === 'complete') {
        initializePage();
    } else {
        window.addEventListener('load', initializePage);
    }

    // Also listen for postMessage events (fallback)
    window.addEventListener("message", (event) => {
        console.log("Received postMessage event:", event.origin);
        initializePage();
    });
}

if (ugcFormPage) {
    window.addEventListener("message", (event) => {
        console.log("Form page initialization");

        let parentDomain = detectParentDomain();

        // Development environment check
        if (parentDomain.includes("chm-zuz-dev.fp-non-prod.cloud.netcetera.com")) {
            // Development environment handling
            console.log("Development environment detected");
        } else {
            // Production environment
            const backButton = document.querySelector('.ugc-back-start');
            if (backButton) {
                backButton.setAttribute('href', 'https://formulare.tagblatt.ch/ugc/');
            }
        }
    });
}